

import expo from "./expo.png";
import expo02 from "./expo02.png";
import react from "./react.png";

export default {
  expo,
  expo02,
  react,
};
